import { render } from "./UploadWish.vue?vue&type=template&id=05f090d5&scoped=true"
import script from "./UploadWish.vue?vue&type=script&lang=js"
export * from "./UploadWish.vue?vue&type=script&lang=js"

import "./UploadWish.vue?vue&type=style&index=0&id=05f090d5&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f090d5"]])

export default __exports__